"use strict";var $export=require("./_export"),DEG_PER_RAD=Math.PI/180;$export($export.S,"Math",{radians:function(r){return r*DEG_PER_RAD}});